import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  // eslint-disable-next-line no-console
  console.warn(
    '[vonlof_admin] VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY is missing. ' +
      'Copy .env.example to .env.local and fill in your Supabase credentials.',
  );
}

/**
 * Authenticated Supabase client. The user's session token gates writes via RLS.
 * No service-role key is ever shipped to the browser.
 */
export const supabase = createClient(url ?? 'http://127.0.0.1:54321', anonKey ?? 'public-anon-key', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: 'vonlof-admin-auth',
  },
  db: { schema: 'public' },
  global: {
    headers: { 'x-application-name': 'vonlof-admin' },
  },
});